module.exports = __webpack_public_path__ + "static/img/nav2.fe0d87f5.png";